.skeleton {
  display: block;
  background-color: var(--color-skeleton);
  background-image: linear-gradient(
    90deg,
    transparent 0%,
    var(--color-skeleton-highlight) 50%,
    transparent 100%
  );
  background-size: 200% 100%;
  background-repeat: no-repeat;
  animation: shimmer 1.4s var(--ease-in-out) infinite;
}

.text {
  width: 100%;
  height: 0.75em;
  margin: 0.25em 0;
  border-radius: var(--radius-sm);
}

.rect {
  width: 100%;
  height: 4rem;
  border-radius: var(--radius-md);
}

.circle {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.stack {
  display: flex;
  flex-direction: column;
  width: 100%;
}

@keyframes shimmer {
  from {
    background-position: 150% 0;
  }
  to {
    background-position: -50% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none !important;
    background-image: none;
  }
}
